import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { Methods } from '@/api/v1/cart/shipping-information'
import { isDenebEnabled } from '@/const/flags'
import { aspidaClient } from '@/lib/aspida'
import { queryClient } from '@/lib/react-query'
import { useProxyStore } from '@/providers/proxyStore/ProxyStoreContext'

import { cartKeyFactory } from './key'

export type UpdateShippingInfoDTO = {
  storeCode?: string | null
  data: Methods['put']['reqBody']
}

type MutationResponse = Awaited<
  ReturnType<typeof aspidaClient.v1.cart.shipping_information.$put>
>

export const updateShippingInfo = ({
  storeCode,
  data,
}: UpdateShippingInfoDTO) => {
  if (isDenebEnabled && storeCode) {
    return aspidaClient.v1.employee.proxy_stores
      ._storeCode(storeCode)
      .cart.shipping_information.$put({ body: data })
  }
  return aspidaClient.v1.cart.shipping_information.$put({ body: data })
}

type UseUpdateShippingInfoOptions = {
  config?: Omit<
    UseMutationOptions<MutationResponse, AxiosError, UpdateShippingInfoDTO>,
    'mutationFn'
  >
}

export const useUpdateShippingInfo = ({
  config,
}: UseUpdateShippingInfoOptions) => {
  const { storeCode } = useProxyStore()

  const mutationFn = ({ data }: UpdateShippingInfoDTO) => {
    if (isDenebEnabled && storeCode) {
      return aspidaClient.v1.employee.proxy_stores
        ._storeCode(storeCode)
        .cart.shipping_information.$put({ body: data })
    }
    return aspidaClient.v1.cart.shipping_information.$put({ body: data })
  }

  return useMutation({
    mutationFn,
    onSuccess: () => queryClient.invalidateQueries(cartKeyFactory.all),
    ...config,
  } as UseMutationOptions<MutationResponse, AxiosError, UpdateShippingInfoDTO>)
}
